import React, { useState } from 'react';
import { useSelector } from 'react-redux';

const PodSelector = ({ selectedPod, onSelect }) => {
  const { pods } = useSelector((state) => state.pods);
  const [showModal, setShowModal] = useState(false);
  const [search, setSearch] = useState('');

  const filteredPods = pods.filter((p) =>
    p.podname.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-600">Pod</label>
      <input
        type="text"
        readOnly
        value={selectedPod?.podname || ''}
        onClick={() => setShowModal(true)}
        className="w-full px-4 py-2 border rounded cursor-pointer bg-gray-50"
        placeholder="Select Pod"
      />

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded w-96 max-h-[80vh] overflow-y-auto">
            <h3 className="text-xl font-bold mb-2">Select Pod</h3>
            <input
              className="w-full mb-3 px-3 py-2 border rounded"
              placeholder="Search pod..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <ul className="space-y-2">
              {filteredPods.map((pod) => (
                <li
                  key={pod.id}
                  onClick={() => {
                    onSelect(pod);
                    setShowModal(false);
                  }}
                  className="cursor-pointer hover:bg-gray-100 p-2 rounded"
                >
                  {pod.podname}
                </li>
              ))}
            </ul>
            <button onClick={() => setShowModal(false)} className="mt-4 text-blue-500">
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PodSelector;
